import { type ThemeParser } from '../../../core/theme';
import { util } from 'echarts/core';
import * as zrender from 'zrender';

// 默认配置
const voronoiSeriesOption = {
  coordinateSystem: 'cartesian2d',
  tooltip: {
    borderWidth: 1,
    borderColor: '#FFFFFF',
    backgroundColor: 'rgba(255,255,255,0.90)',
    extraCssText: 'box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.2);'
  }
};

function parseVoronoiSeries(option: Parameters<ThemeParser>[0]) {
  option.series = option.series.map(item => {
    if (item.type !== 'custom' || (item.type === 'custom' && item.dvType !== 'voronoi')) {
      return item;
    }
    const mergeOption = util.merge(item, voronoiSeriesOption, true);
    return mergeOption;
  });
}

/**
 * 沃洛诺伊图解析器
 */
export function voronoiThemeParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  const option = args[0];
  parseVoronoiSeries(option);
}
